export enum ExhibitedProductTypes {
  GET__EXHIBITED_PRODUCTS_START = 'GET__EXHIBITED_PRODUCTS_START',
  GET__EXHIBITED_PRODUCTS_SUCCESS = 'GET__EXHIBITED_PRODUCTS_SUCCESS',
  GET__EXHIBITED_PRODUCTS_FAILURE = 'GET__EXHIBITED_PRODUCTS_FAILURE',
}
